// PartTrackStepState (N13) -> rótulo i18n del estado de una operación EN LA TRAZA DE UNA PIEZA.
//
// ⚠️⚠️ ES EL MISMO JOB DEL WORKFLOW VISTO PARA UNA PIEZA CONCRETA, y por eso —decisión del PO del
// 23/09— dice su estado con LAS MISMAS PALABRAS Y LA MISMA PÍLDORA que Workflow y Progress: «Pending»,
// «In execution», «Finished». Las claves de rótulo son las de `operationStatus.js`, reutilizadas.
// (Aquí hubo claves propias —«Step pending», «Step in progress», «Step done»— porque creímos que era
// otro significado. No lo era: es el mismo estado con menos detalle.)
//
// ⚠️ LO ÚNICO QUE CAMBIA ES EL DETALLE: de las filas de `PartWorkflowHistory` solo se pueden deducir
// TRES estados —`DONE` (hay una fila cerrada), `IN_PROGRESS` (hay una abierta) y `PENDING` (la pieza
// NO ha llegado a esta operación, S201/S203)—, no los ocho de la operación.
//
// ⚠️⚠️ Y POR ESO LOS MAPAS SIGUEN SEPARADOS, aunque los rótulos coincidan: la separación la justifica
// el ENUM, no el significado. `DONE` no existe en `OperationStatus`, e `IN_PROGRESS` coincide en
// nombre por casualidad con un valor que allí se retiró (S449). Importar `operationStatusView` aquí
// habría «funcionado» para un valor y dejado otro roto. Se reutilizan las CLAVES, no el mapa.
//
// ⚠️ DEFECTO QUE ESTO CORRIGIÓ en su día (S369, visto en factory-lab): no había mapa — un único caso
// cableado, así que `IN_PROGRESS` y `DONE` se pintaban EN CRUDO. 35 apariciones en una sola orden.
/**
 * Story 204 (RN1.5, P1-bis): the legacy keys of the states whose text still differs from the same code elsewhere
 * (`IN_PROGRESS` reads "In execution" by PO decision of 23/09; `PENDING` is a shared key with another text) — the
 * same keys `operationStatus.js` uses for ACTIVE_EXECUTION and PENDING. `DONE` is asked by its own code, which carries
 * the text `Finished` had. Passed as `labelKeys` to SystemValueChip.
 *
 * ⚠️ A value outside the three is painted RAW on purpose (systemValueLabel does it, RN1.2): if Sun adds a fourth state,
 * seeing it as is is ugly but informs, and vanishing would leave the column blank without anything failing — which is
 * exactly how this defect survived three weeks.
 */
export const PART_TRACK_STEP_STATE_LEGACY_KEYS = Object.freeze({
  IN_PROGRESS: 'Executing operation',
  PENDING: 'Pending operation'
})

/**
 * ¿Ha llegado la pieza a esta operación?
 *
 * La tabla oculta fecha, máquina, lote y resultado mientras no ha llegado — no son datos ausentes,
 * es que todavía no existen. Vive aquí y no repetido en cuatro celdas porque es conocimiento de
 * ESTE enum: si Sun renombra el estado, se rompe en un sitio y no en cuatro.
 */
export const partTrackStepReached = (state) => state !== 'PENDING'

// El ICONO Y COLOR de cada estado del paso, los de la píldora compartida (`SystemValueChip`, aspecto `chip`), igual que
// los rótulos de arriba.
// Mapeo decidido por el PO (23/09): pendiente ↔ el de PENDING, en curso ↔ el de ACTIVE_EXECUTION (en
// marcha), hecho ↔ el de FINISHED. Un estado desconocido no recibe ninguno: sale sin icono y neutro.
const PART_TRACK_STEP_ICON_KEYS = {
  DONE: 'finished',
  IN_PROGRESS: 'active-execution',
  PENDING: 'pending'
}
export const partTrackStepIconKey = (state) => PART_TRACK_STEP_ICON_KEYS[state] || ''
